module.exports = __webpack_public_path__ + "img/male-condom_x2.93a6fe95.png";